module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?174c02fc4609e8fc4389f5d21f16a296";